<div>
  <div class="profileCard">
    <mat-card appearance="raised">
      <mat-card-title style="text-align: center;">User Profile</mat-card-title>
      <mat-card-content>
        <table width="100%">
          <tr>
            <td class="label">
              Username
            </td>
            <td class="value">
              {{currentUser?.name}}
            </td>
            <td>
              <!-- button mat-icon-button color="primary" class="edit" disabled="true">
              <mat-icon style="font-size: 14px;">edit</mat-icon>
              </button -->
            </td>
            @if (!isMobile) {
              <td class="help">
                This is the name that you will be known by in the system. It is displayed when someone
                hovers on your avatar.
              </td>
            }
          </tr>
          <tr>
            <td class="label">
              Email Address
            </td>
            <td class="value">
              <div style="float:left">
                {{currentUser?.email}}
              </div>
            </td>
            <td></td>
            @if (!isMobile) {
              <td class="help" >
                Used to login and for all communications from OurOMC to you.
              </td>
            }
          </tr>
          <tr>
            <td class="label">
              Avatar
            </td>
            <td class="value">
              <app-avatar [id]="currentUser?.id"></app-avatar>
            </td>
            <td>
              <!-- button mat-icon-button color="primary" class="edit" disabled="true">
              <mat-icon style="font-size: 14px;">edit</mat-icon>
              </button -->
            </td>
            @if (!isMobile) {
              <td class="help" >
                This is displayed in the top left corner of screen and on any posts and comments you make in
                the system
              </td>
            }
          </tr>
        </table>
        @if (createAgencyAllowed()) {
          <button
          mat-raised-button (click)="createAgency()" color='primary'>Create Agency</button>
        }
        @if (fieldLabAllowed()) {
          <a mat-raised-button color="primary" [routerLink]="[fieldLabUrl, {_view: 'allFilters'}]"
            style="margin-left: 10px">Field Lab</a>
        }
        <app-purge-test-company></app-purge-test-company>
        <app-password-resets></app-password-resets>
        <app-error-logs></app-error-logs>
      </mat-card-content>
    </mat-card>
    @if (createAgencyAllowed()) {
        <div style="margin-top: 20px">
            <app-stats></app-stats>
        </div>
        
    }
  </div>

